import { Accordion, AccordionActions, AccordionDetails, AccordionSummary, Button } from '@mui/material'
import React, { useState } from 'react'
import { useSnackbar } from "notistack";
import { useMailChimpReportMutation } from "../../generated/graphql";
import FileSaver from 'file-saver';

export default function MailChimpContacts() {
    const [isWait, setWait] = useState(false);
    const {enqueueSnackbar} = useSnackbar();
    const [mutation] = useMailChimpReportMutation({ fetchPolicy: 'no-cache' });

    async function submitForm() {
        if (isWait) return;
        enqueueSnackbar("Generating report",{color:'primary'});
        setWait(true);
        try {
            const data = await mutation();
            setWait(false);
            enqueueSnackbar('Rendering file',{color:'success'});
            const res = await fetch(data?.data?.mailChimpReport?.reportData);
            const blobContent = await res.blob();
            //const blobUrl = URL.createObjectURL(blobContent);
            FileSaver.saveAs(blobContent,'mailchimp-report-.xlsx');
            //window.open(blobUrl);
            
        } catch (e) {
            console.log('error',e);
            enqueueSnackbar('Download failed',{color:'error'});
            setWait(false);
        }
    }
    return <div><div>
    <Accordion defaultExpanded={true}>
        <AccordionSummary>MailChimp Contacts Export</AccordionSummary>
        <AccordionDetails>
            </AccordionDetails>
            <AccordionActions>
                  <Button variant="contained" onClick={submitForm}>Generate Report</Button>
            </AccordionActions>
    </Accordion></div></div>
}
